import * as React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Grid } from '@material-ui/core';
import get from 'lodash/get';
import IssueLabel from '@hydra/routes/crawler/components/IssueLabel';

import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import DCUrlLabel from '@hydra/routes/crawler/components/DCUrlLabel';
import StructuredDataIssueText from '@hydra/common/components/StructuredDataIssueText';

export class ProductIssuesRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;

    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const sourceUrl = new DCUrl(domain, issue.source_url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <IssueLabel severity={issue.level}>
            <StructuredDataIssueText issue={issue.issue} />
          </IssueLabel>
        </Grid>
        <Grid item {...columnStyles[1]}>
          <DCUrlLabel url={sourceUrl} severity={3} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(ProductIssuesRow, {
  issue: graphql`
    fragment ProductIssuesRow_issue on ProductIssue {
      id
      source_url
      issue
      level
      name
    }
  `
});
